import React from 'react';
import { canStartNewGame } from 'services/helper-services/utils';
import { BackfieldLink, GameCardWrapper, Text, Title } from './GameCardOverlayStyles';

interface IProps {
  isGameActive: boolean;
  isConnectedToRadar: boolean;
  isActiveFieldPresent: boolean;
  isLoggedIn: boolean;
  isBackfield: boolean;
  managementAppUrl: string;
  updating: boolean;
}
export const GameCardOverlay: React.FC<IProps> = (props: IProps) => {
  const { isGameActive, isConnectedToRadar, isActiveFieldPresent, isLoggedIn, isBackfield, managementAppUrl, updating } = props;
  const shouldDisplayOverlay = !canStartNewGame(isGameActive, isActiveFieldPresent, isBackfield, isConnectedToRadar, isLoggedIn, updating);

  if (!shouldDisplayOverlay) {
    return null;
  }

  const getTitle = () => {
    if (updating) {
      return 'UPDATING TRACKING ELEMENTS';
    }

    if (!isConnectedToRadar) {
      return 'RADAR DISCONNECTED';
    }

    if (isBackfield) {
      if (!isLoggedIn) {
        return 'USER NOT LOGGED IN';
      }
    }
    return 'CONFIGURATION MISSING';
  };

  const getFirstRow = () => {
    if (updating) {
      return 'It might take a few minutes before you can start tagging a game';
    }
    if (!isConnectedToRadar) {
      return 'You need to connect to radar before starting a new game';
    }
    if (isBackfield) {
      if (!isLoggedIn) {
        return 'You need to log in using Management App before starting a new game';
      }
    }
    return 'There is no system configuration present';
  };

  const getSecondRow = () => {
    if (!isConnectedToRadar) {
      return '';
    }

    if (isBackfield) {
      if (!isLoggedIn) {
        return (
          <>
            You can find it <BackfieldLink href={managementAppUrl}>here</BackfieldLink>
          </>
        );
      }

      return "If you're using Backfield, connect to a PTU";
    }
    return '';
  };

  return (
    <GameCardWrapper>
      <Title>{getTitle()}</Title>
      <Text>
        <div>{getFirstRow()}</div>
        <div>{getSecondRow()}</div>
      </Text>
    </GameCardWrapper>
  );
};
